import type { IRecipient } from '@lib-shared/types/Recipient';

export class DocumentHelper {
  static getRecipientById(recipientId: string, recipients: IRecipient[]): IRecipient {
    return recipients.find((recipient: IRecipient) => recipient.id === recipientId);
  }
}
